<form>
   <div class="sam-form-row" *ngIf="featureEnabled$ | async">
      <label class="k-checkbox-label" for="showCallInfo">
         <input
            type="checkbox"
            id="showCallInfo"
            [checked]="showCallInfo$ | async"
            (click)="changeShowCallInfo($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.stage_brick.settings.show_call_info' | translate }}</label
      >
   </div>
   <div class="sam-form-row" *ngIf="featureEnabled$ | async">
      <label class="k-checkbox-label" for="showHistory">
         <input
            type="checkbox"
            id="showHistory"
            [checked]="showHistory$ | async"
            (click)="changeShowHistory($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.stage_brick.settings.show_history' | translate }}</label
      >
   </div>
   <div class="sam-form-row" *ngIf="featureEnabled$ | async">
      <label class="k-checkbox-label" for="showNextDialTarget">
         <input
            type="checkbox"
            id="showNextDialTarget"
            [checked]="showNextDialTarget$ | async"
            (click)="changeShowNextDialTarget($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.stage_brick.settings.show_next_dial_target' | translate }}</label
      >
   </div>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showDefaultBackground">
         <input
            type="checkbox"
            id="showDefaultBackground"
            [checked]="showDefaultBackground$ | async"
            (click)="changeShowDefaultBackground($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.stage_brick.settings.show_default_background' | translate }}</label
      >
   </div>
   <div>
      <samweb-action [brickInstanceId]="brickInstanceId" [toolbarId]="'toolbar'"></samweb-action>
   </div>
</form>
